/**
 * Scroll-reveal oficial del Sistema Mejoris — progressive enhancement.
 * Promovido desde page-dermapatch.js (Sprint 1) para que cualquier
 * landing lo use sin repetir el script.
 *
 * Marca cualquier elemento con `data-reveal` y, al entrar en viewport,
 * le agrega la clase `mejoris-revealed`. El estado oculto SOLO se activa
 * si este script corrió (agrega `mejoris-reveal-active` a <html>), así un
 * fallo de carga del script nunca deja contenido invisible — ver
 * assets/mejoris-reveal.css para las reglas de opacidad/transform.
 *
 * Uso: agrega `data-reveal` a cualquier elemento en cualquier landing.
 * No requiere configuración ni inicialización manual.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;

  document.documentElement.classList.add('mejoris-reveal-active');

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mejoris-revealed');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach(function (el) { io.observe(el); });
})();
